// COLLAB EXPERIENTIAL — central content source of truth
export const BRAND = {
  name: "COLLAB",
  suffix: "Experiential",
  tagline: "We ignite brand stories and drive impact.",
  address: "Studio 04, 1180 Franklin Ave, Brooklyn NY",
  email: "abhinav@collabexp.com",
  phone: "+91 98113 52070",
  socials: [
    { label: "Instagram", href: "https://www.instagram.com/collab_exp/" },
    { label: "LinkedIn", href: "https://linkedin.com" },
  ],
};

export const HERO_LINES = [
  "We ignite",
  "brand stories",
  "and drive impact",
];

export const CHAPTERS = [
  {
    n: "00",
    title: "The premise",
    body: "A brand becomes real the moment a stranger stands inside it. We design that moment.",
    image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=900&auto=format&fit=crop",
  },
  {
    n: "01",
    title: "The craft",
    body: "Concept, fabrication, script, sound, scent, service. Every layer is authored, nothing left to chance.",
    image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=900&auto=format&fit=crop",
  },
  {
    n: "02",
    title: "The room",
    body: "Space is our medium. Light, material and rhythm compose the argument before anyone speaks.",
    image: "https://images.unsplash.com/photo-1519750157634-b6d493a0f77c?w=900&auto=format&fit=crop",
  },
  {
    n: "03",
    title: "The memory",
    body: "The point isn’t the event. The point is what people carry home and can’t stop describing.",
    image: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=900&auto=format&fit=crop",
  },
];

export const SERVICES = [
  {
    code: "S / 01",
    title: "Brand Activations",
    body: "Pop-ups, launches, and cultural moments that arrive with intent and leave a trace.",
  },
  {
    code: "S / 02",
    title: "Event Production",
    body: "From 40-person dinners to 8,000-person festivals, produced with obsessive detail.",
  },
  {
    code: "S / 03",
    title: "Retail Environments",
    body: "Flagship interiors and in-store theatre that turn visits into rituals.",
  },
  {
    code: "S / 04",
    title: "Experiential Strategy",
    body: "The concept, the argument, the storyline — before a single wall goes up.",
  },
  {
    code: "S / 05",
    title: "Content & Capture",
    body: "Film, stills, sound design and social edits that let the moment travel.",
  },
  {
    code: "S / 06",
    title: "Fabrication",
    body: "In-house build, from milled timber and CNC steel to soft goods and signage.",
  },
];

export const WORK = [
  {
    id: "grounded",
    title: "Grounded",
    client: "Halcyon Coffee Co.",
    year: "2024",
    tag: "Brand Launch",
    image: "https://images.unsplash.com/photo-1511920170033-f8396924c348?w=1400&auto=format&fit=crop",
    span: "wide",
  },
  {
    id: "afterglow",
    title: "Afterglow",
    client: "Meridian Music Festival",
    year: "2024",
    tag: "Festival Immersion",
    image: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&auto=format&fit=crop",
    span: "tall",
  },
  {
    id: "atrium",
    title: "The Atrium",
    client: "Oren Studio",
    year: "2023",
    tag: "Flagship Retail",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&auto=format&fit=crop",
    span: "standard",
  },
  {
    id: "signal",
    title: "Signal / Noise",
    client: "Foundry Devices",
    year: "2024",
    tag: "Product Reveal",
    image: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=1400&auto=format&fit=crop",
    span: "wide",
  },
  {
    id: "wild",
    title: "Wild Provisions",
    client: "Sourwood Market",
    year: "2023",
    tag: "Field Activation",
    image: "https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=1200&auto=format&fit=crop",
    span: "standard",
  },
  {
    id: "nightshift",
    title: "Nightshift",
    client: "Loam Spirits",
    year: "2025",
    tag: "After-hours Series",
    image: "https://images.unsplash.com/photo-1493770348161-369560ae357d?w=1200&auto=format&fit=crop",
    span: "tall",
  },
];

export const TEAM = [
  {
    name: "Delton R. Smith",
    role: "Chief Executive Officer",
    bio: "Fifteen years producing brand moments across four continents. Believes the room does the talking.",
    image:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=900&auto=format&fit=crop",
  },
  {
    name: "Charles K. Smith",
    role: "General Manager",
    bio: "Operations lead behind our largest festival and retail programs. Runs the studio on quiet nerve.",
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=900&auto=format&fit=crop",
  },
  {
    name: "Brennan Smith",
    role: "Creative Director",
    bio: "Set designer turned brand author. Draws every day before nine a.m.",
    image:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=900&auto=format&fit=crop",
  },
];

export const NUMBERS = [
  { k: "12", v: "years in practice" },
  { k: "38", v: "cities activated" },
  { k: "180+", v: "productions delivered" },
  { k: "07", v: "Cannes shortlists" },
];
